export default __webpack_public_path__ + "static/media/sh_x_livingos.1bf140d4.svg";